import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import getters from './getters'
import user from './modules/user'
import tab from './modules/tab'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    user,
    tab,
    getters
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
  state: {},
  mutations: {},
  getters: {},
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store/store.js